import { render, staticRenderFns } from "./ReservationList.vue?vue&type=template&id=fe06546a&scoped=true&"
import script from "./ReservationList.vue?vue&type=script&lang=js&"
export * from "./ReservationList.vue?vue&type=script&lang=js&"
import style0 from "./ReservationList.vue?vue&type=style&index=0&id=fe06546a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe06546a",
  null
  
)

export default component.exports